import { useCallback, useState } from 'react';

import { useDispatch } from 'react-redux';

import { AxiosError, AxiosResponse } from 'axios';

import { getRentAssetUrl } from 'config/api';

import { getEntitlements } from 'store/user/actions';
import { RequestErrorData } from 'store/user/reducer.types';

import NagraInstance from 'utils/axios/nagra/DefaultInstance';

export default function useRent() {
    const dispatch = useDispatch();
    const [errorCode, setErrorCode] = useState<string>('');
    const [errorStatus, setErrorStatus] = useState<number | undefined>();
    const [data, setData] = useState<AxiosResponse>();

    const rentAsset = useCallback(async (contentId: string) => {
        try {
            if (contentId) {
                const response = await NagraInstance.post(
                    getRentAssetUrl(),
                    {
                        productId: contentId,
                    },
                    {
                        headers: {
                            'nv-tenant-id': 'nagra',
                            'content-type': 'application/json',
                        },
                    },
                );

                if (response.status === 201) {
                    setData(response.data);
                    dispatch(getEntitlements({ autoRetry: true }));
                }
            }
        } catch (err) {
            setErrorCode(
                `${
                    ((err as AxiosError).response?.data as RequestErrorData)
                        ?.errorCode
                }`,
            );
            setErrorStatus((err as AxiosError).response?.status);
        }

        return () => {
            setErrorCode('');
            setErrorStatus(undefined);
        };
    }, []);

    return {
        errorCode,
        errorStatus,
        data,
        rentAsset,
    };
}
